<template>
	<div style="display: flex; align-items: center;">
		<input
			ref="input"
			:type="inputType"
			:inputmode="inputMode"
			autocomplete="one-time-code"
			maxlength="1"
			pattern="[0-9]"
			v-model="model"
			:class="inputClasses"
			@input="handleOnChange"
			@keydown="handleOnKeyDown"
			@paste="handleOnPaste"
			@focus="handleOnFocus"
			@blur="handleOnBlur"
		/>
		<span v-if="!isLastChild && separator">
			<span v-html="separator"></span>
		</span>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: String,
		},

		separator: {
			type: String,
		},

		focus: {
			type: Boolean,
		},

		inputClasses: {
			type: String,
		},

		shouldAutoFocus: {
			type: Boolean,
		},

		inputType: {
			type: String,
			default() {
				return 'tel';
			},
		},

		inputMode: {
			type: String,
			default() {
				return 'text';
			},
		},

		isLastChild: {
			type: Boolean,
		},
	},

	data() {
		return {
			model: this.value || '',
		};
	},

	watch: {
		value(newValue, oldValue) {
			if (newValue !== oldValue) {
				this.model = newValue;
			}
		},
		// whenever question changes, this function will run

		focus(newFocusValue, oldFocusValue) {
		// Check if focusedInput changed
		// Prevent calling function if input already in focus
		if (oldFocusValue !== newFocusValue && (this.$refs.input && this.focus)) {
			this.$refs.input.focus();
		}
		},
	},
	methods: {
		handleOnFocus() {
			return this.$emit('on-focus');
		},

		handleOnChange() {
			if (this.model.length > 1) {
				this.model = this.model.slice(0, 1);
			}
			return this.$emit('on-change', this.model);
		},

		handleOnKeyDown(event) {
			// Only allow characters 0-9, DEL, Backspace, Enter, Right and Left Arrows, and Pasting
			const keyEvent = (event) || window.event;
			const charCode = (keyEvent.which) ? keyEvent.which : keyEvent.keyCode;
			if (this.isCodeNumeric(charCode) || [8, 9, 13, 37, 39, 46, 86].includes(charCode)) {
				this.$emit('on-keydown', event);
			} else {
				keyEvent.preventDefault();
			}
		},

		isCodeNumeric(charCode) {
			// numeric keys and numpad keys
			return (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105);
		},

		handleDefaultValue(event) {
			return this.$emit('on-paste', event);
		},

		handleOnPaste(event) {
			return this.$emit('on-paste', event);
		},

		handleOnBlur() {
			return this.$emit('on-blur');
		},
	},

	mounted() {
		if (this.$refs.input && this.focus && this.shouldAutoFocus) {
			this.$refs.input.focus();
		}
	},
};
</script>
